import * as z from 'zod';

export const emailSchema = z
  .string()
  .nonempty({ message: 'メールアドレスを入力してください。' })
  .refine(
    value =>
      !value ||
      /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/.test(
        value
      ),
    { message: 'メールアドレスの書式に誤りがあります。' }
  );

export const passwordSchema = z
  .string()
  .nonempty({ message: 'パスワードを入力してください。' })
  .refine(
    value => !value || /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(value),
    { message: '半角英数字をそれぞれ1種類以上含む8文字以上でご登録ください。' }
  );
